import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PageTransition from "../components/PageTransition";
import { useTranslation } from "../i18n/LanguageContext";

export default function NotFound() {
  const location = useLocation();
  const t = useTranslation();

  return (
    <PageTransition>
      <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-6 pt-20">
        <p className="font-serif text-[120px] leading-none text-border mb-6">404</p>
        <h1 className="font-serif text-2xl mb-2">{t.notfound_title}</h1>
        <p className="text-secondary text-[15px] mb-10 font-mono">{location.pathname}</p>
        <Link to="/" className="inline-flex items-center gap-2 text-[13px] font-semibold text-accent hover:text-accent-dark transition-colors duration-300">
          <ArrowLeft size={14} /> {t.notfound_back}
        </Link>
      </div>
    </PageTransition>
  );
}
